/**
 * Static placeholder shown while Clerk's JS bundle mounts the `/login` card or
 * the `<SignUp>` widget on the client. Mirrors the card's shape — social
 * buttons, divider, email field, submit — at its real height so the swap to the
 * live card is near-seamless and the card never collapses. `/login` puts its
 * Google and Apple in one row; Clerk's `<SignUp>` stacks its options.
 *
 * The parent page reserves the same min-height across the
 * `<ClerkLoading>`/`<ClerkLoaded>` swap so there is no layout shift when Clerk
 * takes over (including during the widget's own internal first render).
 */
export const AUTH_WIDGET_MIN_HEIGHT = {
  'sign-in': 'min-h-[320px]',
  'sign-up': 'min-h-[480px]',
} as const;

export function AuthWidgetSkeleton({
  variant = 'sign-up',
}: {
  variant?: keyof typeof AUTH_WIDGET_MIN_HEIGHT;
}) {
  return (
    <div
      role="status"
      aria-label="Loading sign-in"
      className={`flex ${AUTH_WIDGET_MIN_HEIGHT[variant]} w-full flex-col gap-4 rounded-2xl bg-white shadow-2xl ${variant === 'sign-in' ? 'p-5 sm:p-6' : 'p-6'}`}
    >
      {/* Social buttons (top) */}
      <div className={variant === 'sign-in' ? 'grid grid-cols-2 gap-2' : 'flex flex-col gap-3'}>
        <div className="h-11 w-full animate-pulse rounded-full bg-black/[0.06]" />
        <div className="h-11 w-full animate-pulse rounded-full bg-black/[0.06]" />
        {variant === 'sign-up' ? (
          <div className="h-11 w-full animate-pulse rounded-full bg-black/[0.06]" />
        ) : null}
      </div>
      {/* OR divider */}
      <div className="flex items-center gap-3 py-1">
        <span className="h-px flex-1 bg-black/10" />
        <span className="h-2.5 w-6 animate-pulse rounded bg-black/[0.06]" />
        <span className="h-px flex-1 bg-black/10" />
      </div>
      {/* Email field */}
      <div className="space-y-2">
        <div className="h-3 w-24 animate-pulse rounded bg-black/10" />
        <div className="h-11 w-full animate-pulse rounded-lg bg-black/[0.06]" />
      </div>
      {/* Submit */}
      <div className="mt-1 h-11 w-full animate-pulse rounded-full bg-[#FA5E4F]/25" />
      <span className="sr-only">Loading…</span>
    </div>
  );
}
